<template>
  <BaseSection is-wide>
    <template #content>
      <BaseText
        is-block
        data-animation="fadeInTop"
        data-animation-delay="100"
        v-html="'<mark>HR-бренд компании –</mark> это положительный имидж работодателя на рынке труда. Знание о&nbsp;том, как формировались HR&#8209;бренд и&nbsp;трудовая культура в&nbsp;России на протяжении последнего столетия, позволит понять текущую ситуацию'"
      />
      <div class="section__history section__gap">
        <TheHistory :cards="cards" :delay="300" />
      </div>
      <hr
        class="app__sep"
        data-animation="fadeIn"
        data-animation-delay="600"
      />
      <BaseText
        size="m"
        data-animation="fadeInRight"
        data-animation-delay="900"
        v-html="'Российский опыт трудовых отношений выявил не только значимость труда и&nbsp;сформированных вокруг процессов, но&nbsp;и&nbsp;к&nbsp;людей, которые делают их возможными. Именно для этого 21&nbsp;век положил в&nbsp;основу HR&#8209;бренда ценностное предложение работодателя (EVP, employment value proposition) — набор преимуществ, которые получает сотрудник, работая в&nbsp;компании. По сути, именно EVP отвечает на вопрос:'"
      />
      <div class="section__gap">
        <BaseText
          data-animation="fadeInRight"
          data-animation-delay="1200"
          size="l"
          is-bold
        >
          <i>«почему я хочу работать именно здесь?»</i>
        </BaseText>
      </div>
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseText from '@/components/BaseText.vue';
import TheHistory from '@/components/TheHistory.vue';

export default {
  name: 'TransformationPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseText,
    TheHistory,
  },
  staticData: () => ({
    cards: [
      {
        color: 'red',
        title: 'Дореволюци<wbr>онный период',
        period: 'к 19 – н 20 вв.',
        text: 'Пренебрежительное отношение большой части рабочих к&nbsp;деньгам, умеренность в&nbsp;работе и&nbsp;отсутствие карьерных устремлений современного типа (желание повышать квалификации, добиться уважения в&nbsp;коллективе)',
      },
      {
        color: 'yellow',
        title: 'Довоенный период',
        period: '1920е – 1930е гг.',
        text: 'Появление системы стимулов к&nbsp;труду (льготы) и&nbsp;форм морального и общественного поощрения (грамоты); увеличение нагрузки; ассоциирование труда с&nbsp;борьбой и&nbsp;подвигом (период пятилеток)',
      },
      {
        color: 'green',
        title: 'Военный и&nbsp;послевоенный период',
        period: '1940е – 1950е гг.',
        text: 'Выход на первый план натуральной материальной мотивации (питание, жилье, отдых); труд с опорой на сознательность, «завод – моя семья»',
      },
      {
        color: 'red',
        title: 'Советские времена',
        period: '1960е – 1980е гг.',
        text: 'Сдерживание денежной мотивации при росте натуральной неденежной; придерживание материальных стимулов под лозунгом «Превращение труда в первую жизненную потребность»',
      },
      {
        color: 'yellow',
        title: 'Распад СССР',
        period: '1990е гг.',
        text: 'Противоречие между развитием потребительской революции и&nbsp;коммунистическими призывами к&nbsp;труду привело к&nbsp;появлению и&nbsp;расширению теневой экономики; появление идеи работы во благо себя, а&nbsp;не&nbsp;во&nbsp;благо общества',
      },
      {
        color: 'green',
        title: 'Наше время',
        period: '2000е – 2020 гг.',
        text: 'Рост частного бизнеса и, как следствие, интерес к&nbsp;работе ради получения опыта и&nbsp;денежного вознаграждения; появление идеи работать во&nbsp;благо своей компании',
      },
      {
        color: 'black',
        title: 'Коронакризис',
        period: '2020 г.',
        text: 'Неустойчивое положение в&nbsp;организации работы компаний, нестабильная экономическая активность, распространение удаленных форматов взаимодействия и&nbsp;рост цифрового неравенства',
      },
    ],
  }),
};
</script>
